import Vue from 'vue'
let  VueEventBus = new Vue()///声明变量



export default VueEventBus



// WEBPACK FOOTER //
// ./src/model/VueEventBus.js